import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconWatermarkProtection = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 21,
	viewBox: "0 0 19 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.69045 19.5795H4.72371C3.73819 19.5795 2.79303 19.1879 2.09617 18.4911C1.3993 17.7942 1.00781 16.8491 1.00781 15.8636V12.9745C1.00781 9.79859 2.2694 6.75288 4.51505 4.50724C6.7607 2.26159 9.80643 1 12.9823 1H14.0135C14.9989 1 15.9442 1.39149 16.641 2.08836C17.3378 2.78523 17.7294 3.73037 17.7294 4.71589V9.76942",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 13.1324C1 8.33889 6.10939 12.2033 9.10994 9.19345C12.1105 6.18363 8.27386 1 13.0581 1",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.3333 15.6667V14.3333C15.3333 14.2843 15.3957 14.243 15.6353 14.133C16.021 13.957 16.6667 13.6617 16.6667 12.6667C16.6667 11.3483 15.5763 11 15 11H13C12.4237 11 11.3333 11.3483 11.3333 12.6667C11.3333 13.6617 11.979 13.957 12.3647 14.133C12.6043 14.243 12.6667 14.2843 12.6667 14.3333V15.6667H10V18.3333H10.6667V19H17.3333V18.3333H18V15.6667H15.3333ZM12.6417 13.527C12.2833 13.363 12 13.2337 12 12.6667C12 11.7257 12.8343 11.6687 13 11.6667H14.9983C15.1657 11.6687 16 11.7257 16 12.6667C16 13.2337 15.7167 13.363 15.3583 13.527C15.0663 13.6603 14.6667 13.843 14.6667 14.3333V15.6667H13.3333V14.3333C13.3333 13.843 12.9337 13.6603 12.6417 13.527ZM17.3333 17.6667H10.6667V16.3333H17.3333V17.6667Z",
			fill: "currentColor"
		})
	]
});
export default SvgIconWatermarkProtection;
